const camelCaseToPlainText = (camelCaseString: string): string => {
    if (!camelCaseString) {
        return '';
    }
    const spacedString = camelCaseString.replace(/([a-z])([A-Z])/g, '$1 $2');
    const firstLetterCapitalized = spacedString.charAt(0).toUpperCase() + spacedString.slice(1);
    return firstLetterCapitalized;
};

const escapeCsv = (value: string): string => {
    const needsQuotes = (/[,"\n]/).test(value);
    const escaped = value.replace(/"/g, '""');
    return needsQuotes ? `"${escaped}"` : escaped;
};

export const generateCsv = <T>({ data, columns, rowFormatter, filename = 'transactions.csv' }: {data: T[]; columns: (keyof T)[] | string[]; rowFormatter?: (item: T) => string[]; filename?: string}): void => {
    try {
        if (!Array.isArray(data) || data.length === 0) {
            throw new Error('Data must be a non-empty array');
        }

        if (!Array.isArray(columns) || columns.length === 0) {
            throw new Error('Columns must be a non-empty array');
        }

        const header = columns.map(column => {
            return camelCaseToPlainText(String(column));
        }).join(',');

        const rows = data.map(item => {
            if (rowFormatter) {
                return rowFormatter(item).join(',');
            }

            return columns.map(key => {
                if (typeof key === 'string') {
                    return escapeCsv(String(item[key as keyof T] || ''));
                }

                return escapeCsv(String(item[key]));
            }).join(',');
        });

        const result = [header, ...rows].join('\n');

        const blob = new Blob([result], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);
    } catch (error) {
        throw new Error(`CSV generation failed: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
};
